import { Navigate } from '@sorare/routing';

import {
  NBA_ONBOARDING_CHOOSE_TEAM,
  NBA_ONBOARDING_CHOOSE_YOUR_LEVEL,
} from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

const OnboardingPage = () => {
  const {
    flags: { enableNbaQuickPlayOnboarding = false },
  } = useFeatureFlags();

  if (enableNbaQuickPlayOnboarding) {
    return <Navigate to={NBA_ONBOARDING_CHOOSE_YOUR_LEVEL} replace />;
  }
  return <Navigate to={NBA_ONBOARDING_CHOOSE_TEAM} replace />;
};
export default OnboardingPage;
